export function isDev(): boolean {
  return import.meta.env.DEV
}

export function isProd(): boolean {
  return import.meta.env.PROD
}

export type EnvMode = 'development' | 'test' | 'uat' | 'production'

export function getEnvMode(): EnvMode {
  const mode = import.meta.env.MODE
  if (mode === 'development' || mode === 'test' || mode === 'uat' || mode === 'production') {
    return mode
  }
  // 默认返回 development
  return 'development'
}

export function isDevelopmentMode(): boolean {
  return getEnvMode() === 'development'
}

export function isTestMode(): boolean {
  return getEnvMode() === 'test'
}

export function isUatMode(): boolean {
  return getEnvMode() === 'uat'
}

export function isProductionMode(): boolean {
  return getEnvMode() === 'production'
}
